/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateWorkspaceRequest } from '../models/CreateWorkspaceRequest';
import type { InviteResult } from '../models/InviteResult';
import type { UpdateWorkspaceRequest } from '../models/UpdateWorkspaceRequest';
import type { UpdateWorkspaceResponse } from '../models/UpdateWorkspaceResponse';
import type { Workspace } from '../models/Workspace';
import type { WorkspaceCollaborators } from '../models/WorkspaceCollaborators';
import type { WorkspaceInviteRequest } from '../models/WorkspaceInviteRequest';
import type { WorkspaceResult } from '../models/WorkspaceResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkspaceService {

    /**
     * Add an invite for a user to the workspace.  If the user already has a profile,
     * the profile is immediately added to the workspace.  Otherwise, an invite is
     * created.
     * @param workspaceId The ID of the workspace.
     * @param requestBody The request that includes the configuration of the invite.
     * @returns InviteResult OK
     * @throws ApiError
     */
    public static addCollaborator(
        workspaceId: string,
        requestBody: WorkspaceInviteRequest,
    ): CancelablePromise<InviteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workspaces/{workspaceId}/collaborators/add',
            path: {
                'workspaceId': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Creates a new workspace.
     * @param requestBody The request to create a workspace.
     * @returns Workspace OK
     * @throws ApiError
     */
    public static createWorkspace(
        requestBody?: CreateWorkspaceRequest,
    ): CancelablePromise<Workspace> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workspaces/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Deletes a workspace.
     * @param workspaceId The ID of the project to run.
     * @returns Workspace OK
     * @throws ApiError
     */
    public static deleteWorkspace(
        workspaceId: string,
    ): CancelablePromise<Workspace> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/workspaces/{workspaceId}/delete',
            path: {
                'workspaceId': workspaceId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieves the collaborators and the invites for a given workspace.
     * @param workspaceId The ID of the workspace.
     * @returns WorkspaceCollaborators OK
     * @throws ApiError
     */
    public static getCollaborators(
        workspaceId: string,
    ): CancelablePromise<WorkspaceCollaborators> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workspaces/{workspaceId}/collaborators',
            path: {
                'workspaceId': workspaceId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieves the workspaces for a given user where the user created the workspace,
     * is a member of the workspace, or has an invite to the workspace.
     * @returns WorkspaceResult OK
     * @throws ApiError
     */
    public static getUserWorkspaces(): CancelablePromise<Array<WorkspaceResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workspaces/list',
        });
    }

    /**
     * Creates a new workspace.
     * @param workspaceId The ID of the organization to update.
     * @param requestBody The request to create a workspace.
     * @returns UpdateWorkspaceResponse OK
     * @throws ApiError
     */
    public static updateWorkspace(
        workspaceId: string,
        requestBody?: UpdateWorkspaceRequest,
    ): CancelablePromise<UpdateWorkspaceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/workspaces/{workspaceId}/update',
            path: {
                'workspaceId': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all workspaces that the user belongs to either as a creator or
     * as a member of the organization.
     * @param organizationId The ID of the organization to scope the workspaces for.
     * @returns WorkspaceResult OK
     * @throws ApiError
     */
    public static getWorkspaces(
        organizationId: string,
    ): CancelablePromise<Array<WorkspaceResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workspaces/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
